module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isVisible),
      expression: "this.isVisible"
    }],
    staticClass: "sortHeader noselect right",
    style: ({
      width: _vm.column.width ? _vm.column.width : 'auto;'
    }),
    attrs: {
      "role": "columnheader",
      "aria-sort": _vm.ariaSort,
      "aria-disabled": _vm.ariaDisabled
    },
    on: {
      "click": _vm.clicked
    }
  }, [(_vm.column.isSortable) ? _c('i', {
    class: [_vm.getSortClass(_vm.column)]
  }) : _vm._e(), _vm._v(" "), (_vm.column.isBotton) ? _c('i', {
    class: _vm.column.iconClass
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a62508c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table/TableHeader.vue
// module id = 745
// module chunks = 0